export default __webpack_public_path__ + "static/IMG_1256-fc6728da41d710898e513a454412fc0e.jpg";